<template>
    <div class="iso-booking-form-con" :class="{'show-dialog': showDialog && isBottomBar }">
        <button type="button" class="iso-booking-form-toggle" :class="buttonStyle" @click="onOpenDialog">
            <svg v-if="buttonType === 'link-button'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12" width="16" height="12" aria-hidden="true" focusable="false">
                <path d="M11.5355339 5L8.2426407 1.7071068c-.3905243-.3905243-.3905243-1.0236893 0-1.4142136.3905243-.39052427 1.0236893-.39052427 1.4142135 0l5.6568543 5.6568543-5.6568543 5.6568542c-.3905242.3905243-1.0236892.3905243-1.4142135 0-.3905243-.3905243-.3905243-1.0236893 0-1.4142135L11.4350288 7H1c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h10.5355339z" />
            </svg>
            <span>{{ buttonText }}</span>
        </button>
        <dialog v-show="showDialog || isBottomBar" ref="dialog" :class="[isBottomBar ? 'iso-booking-form-bottom-bar--inner' : 'simple-modal hex-dialog iso-booking-form-modal']" role="dialog" @keydown.esc="onCloseDialog">
            <div role="document" :class="{'simple-modal__wrapper': !isBottomBar}">
                <form ref="form" class="iso-booking-form" method="get" action="/" @submit.prevent="onSubmit">

                    <input type="hidden" name="start" value="" ref="formStartDate" />
                    <input type="hidden" name="end" value="" ref="formEndDate" />
                    <input type="hidden" name="occupancy" value="" ref="formOccupancy" />
                    <input type="hidden" name="salesChannelCode" value="" ref="formSalesChannelCode" />
                    <input type="hidden" name="wrk" value="" ref="formWorkFlow" />
                    <input type="hidden" name="code" value="" ref="formCode" />
                    <input type="hidden" name="hotelCode" value="" ref="formHotelCode" />
                    <input type="hidden" name="utmSource" value="" ref="formUtmSource" />
                    <input type="hidden" name="utmMedium" value="" ref="formUtmMedium" />
                    <input type="hidden" name="utmCampaign" value="" ref="formUtmCampaign" />

                    <div class="iso-booking-form__header">
                        <div class="iso-booking-form__header__inner">
                            <h2 v-text="texts.modalHeadline" class="iso-booking-form__header__headline" v-show="!isBottomBar" />

                            <button type="button" class="simple-modal-close" @click="onCloseDialog" title="Close modal">
                                <span class="simple-modal-close__text">
                                    Close modal
                                </span>

                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
                                    <path fill="currentColor" d="M23.772 8.228a1 1 0 010 1.414l-6.364 6.364 6.364 6.364a1 1 0 01-1.414 1.414l-6.364-6.364-6.364 6.364a1 1 0 01-1.414-1.414l6.364-6.365-6.364-6.363A1 1 0 019.63 8.228l6.365 6.363 6.363-6.363a1 1 0 011.414 0z"></path>
                                </svg>
                            </button>                    
                        </div>
                    </div>

                    <!-- DATES SELECTOR -->
                    <div class="iso-booking-form__dates-wrapper" v-click-outside="clickOutsideDatepicker">
                        <div class="iso-booking-form__headline" data-number="1">{{ texts.headingCheckInOut}}</div>
                        <div class="iso-booking-form__calendar" :class="{ 'show-datepicker': showDatePicker }">
                            <button v-show="isBottomBar" type="button" class="iso-booking-form__calendar__close" @click="showDatePicker = false" title="Close calendar">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
                                    <path fill="currentColor" d="M23.772 8.228a1 1 0 010 1.414l-6.364 6.364 6.364 6.364a1 1 0 01-1.414 1.414l-6.364-6.364-6.364 6.364a1 1 0 01-1.414-1.414l6.364-6.365-6.364-6.363A1 1 0 019.63 8.228l6.365 6.363 6.363-6.363a1 1 0 011.414 0z"></path>
                                </svg>
                            </button>

                            <div class="iso-form-calendar-toggle-button__outer">
                                <button ref="toggleDatePickerButton"
                                        type="button"
                                        class="iso-form-calendar-toggle-button"
                                        :class="{'dates-set': datesSet, 'error': errors.dates}"
                                        @click="toggleDatePicker">
                                    <div class="iso-form-calendar-toggle-button__inner">
                                        <span>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 7.5V6H16.5V7.5C16.5 7.91421 16.8358 8.25 17.25 8.25C17.6642 8.25 18 7.91421 18 7.5V6H21.375C21.5821 6 21.75 6.16789 21.75 6.375V9.75H3V6.375C3 6.16789 3.16789 6 3.375 6H6.75V7.5C6.75 7.91421 7.08579 8.25 7.5 8.25C7.91421 8.25 8.25 7.91421 8.25 7.5ZM18 4.5H21.375C22.4105 4.5 23.25 5.33947 23.25 6.375V10.5V21.375C23.25 22.4105 22.4105 23.25 21.375 23.25H3.375C2.33947 23.25 1.5 22.4105 1.5 21.375V10.5V6.375C1.5 5.33947 2.33947 4.5 3.375 4.5H6.75V2.25C6.75 1.83579 7.08579 1.5 7.5 1.5C7.91421 1.5 8.25 1.83579 8.25 2.25V4.5H16.5V2.25C16.5 1.83579 16.8358 1.5 17.25 1.5C17.6642 1.5 18 1.83579 18 2.25V4.5ZM3 11.25V21.375C3 21.5821 3.16789 21.75 3.375 21.75H21.375C21.5821 21.75 21.75 21.5821 21.75 21.375V11.25H3Z" fill="#211C5B"/>
                                            </svg>
                                        </span>
                                        <span v-text="getCheckinText" class="iso-form-calendar-toggle-button__checkin"></span>
                                    </div>
                                    <div class="iso-form-calendar-toggle-button__inner">
                                        <span v-text="getCheckoutText" class="iso-form-calendar-toggle-button__checkout"></span>
                                    </div>
                                </button>
                            </div>
                            <div class="iso-booking-form__datepicker-con" ref="datepicker" v-show="showDatePicker">
                                <date-picker :locale="getLocale"
                                            color="merlin"
                                            ref="datePicker"
                                            expanded
                                            is-range
                                            :key="datePickerKey"
                                            :max-booking-length="maxBookingLength"
                                            v-model="range"
                                            :attributes="attributes"
                                            @dayclick="onDayClick"
                                            @daykeydown="onDayEnter"
                                            :initial-page="getCalendarStartPosition()"
                                            >
                                </date-picker>
                            </div>

                            <div v-show="errors.dates && !isBottomBar" class="error-message error-message--separated">{{ texts.datesErrorText }}</div>
                        </div>
                    </div>

                    <!-- GUESTS SELECTOR -->
                    <div class="iso-booking-form__guests-wrapper">
                        <div class="iso-booking-form__headline iso-booking-form__headline--guests" data-number="2">{{ texts.headingGuests }}</div>
                        <div class="iso-booking-form__guests-selector-area">
                            <div class="iso-booking-form__guests-selector-area__inner">
                                <div class="iso-booking-form__guests-selector-area__adults" :class="{'error': errors.adults}">
                                    <label :for="adultsLabelID" class="iso-booking-label">{{ texts.adultsPlural }} {{ texts.adultsAgeDescription }}</label>
                                    <increment-decrement-button :min="0" :max="maxAdults" :default="guests.adults" @changeCount="setNumberOfAdults" />
                                    <div v-show="errors.adults && !isBottomBar" class="error-message error-message--separated">{{ texts.adultsErrorText }}</div>
                                </div>

                                <div class="iso-booking-form__guests-selector-area__children" :class="{'error': errors.children}">
                                    <label :for="childrenLabelID" class="iso-booking-label">{{ texts.childrenPlural }} {{ texts.childrenAgeDescription }}</label>
                                    <increment-decrement-button :min="0" :max="maxChildren" :default="guests.children.length" @changeCount="setChildren" @elementClicked="guests.children.length > 0 ? showAgeSelector = true : null" class="iso-booking-form__ages-increment-decrement-button" />
                                </div>
                            </div>

                            <div v-show="showAgeSelector" class="iso-booking-form__guests-selector-area__ages" :class="{'iso-booking-form__guests-selector-area__ages--height-threshold': heightThresholdTurnOn == 'true'}" ref="agePopup" v-click-outside="clickOutsideAgeSelector">
                                <ul class="child-list">
                                    <li v-for="(child, index) in guests.children" :key="index" class="child-list__item">
                                        <label class="iso-booking-label child-label">
                                            {{texts.childrenSingle}} {{index+1}} ({{ texts.age }})
                                        </label>
                                        <div class="iso-booking-select-con">
                                            <select class="small" @change="setChildAge($event, index)">
                                                <option v-bind="{ selected: defaultChildAge == 0 || defaultChildAge == ''}" disabled value="">{{ texts.dropdownDefault }}</option>
                                                <option value="0">0</option>
                                                <option v-bind="{ selected: defaultChildAge == n }" v-for="(n, optionIndex) in maxChildAge" :key="optionIndex" :value="n">{{ n }}</option>
                                            </select>                                        

                                            <label class="iso-booking-input-label child-input-label" v-show="heightThresholdTurnOn == 'true'">
                                                <input type="checkbox" class="iso-booking-input-label" @change="setChildHeightThreshold($event, index)" />
                                                {{ texts.heightThresholdInputText }}
                                            </label>
                                        </div>
                                    </li>
                                </ul>

                                <div class="iso-booking-children-extra-text" v-show="heightThresholdTurnOn == 'true'">{{ texts.heightThresholdExtraText }}</div>
                                <div v-show="errors.children" ref="childerror" class="error-message error-message--separated">{{ texts.childrenErrorText }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="iso-booking-form__actions">
                        <button type="submit" class="button button--primary iso-booking-form__submit" :class="{'iso-booking-form__submit--full-width': buyTicketsOnlyLinkUrl === ''}">{{ texts.searchButton }}</button>
                        <a :href="buyTicketsOnlyLinkUrl" class="button button--hollow iso-booking-form__buy-btn" v-show="isBottomBar && buyTicketsOnlyLinkUrl">{{ texts.buyTicketsOnlyLinkText }}</a>
                    </div>                    
                </form>
            </div>
        </dialog>

    </div>
</template>

<script>
    import Vue from 'vue';
    import { v4 as uuidv4 } from 'uuid';
    import { i18n } from "../../../i18n/vue-hotel-datepicker/i18n.js";
    import dialogPolyfill from 'dialog-polyfill';
    import incrementDecrementButton from '../../shared/incrementDecrementButton.vue'
    import { setupCalendar, DatePicker } from 'v-calendar';
    import vClickOutside from "click-outside-vue3"

    export default {
        name: 'ParentComponent',
        components: {
            DatePicker,
            incrementDecrementButton
        },
        directives: {
            clickOutside: vClickOutside.directive
        },        
        props: {
            isBottomBar: {
                type: Boolean,
                required: false,
                default: () => false
            },
            i18n: {
                type: String,
                required: true,
                default: () => 'en-GB',
            },
            buttonType: {
                type: String,
                required: true,
                default: () => '',
            },
            buttonStyle: {
                type: String,
                required: true,
                default: () => '',
            },
            buttonText: {
                type: String,
                required: true,
                default: () => '',
            },
            availableDates: {
                type: Array,
                required: false,
                default: () => [],
            },
            formStartDate: {
                type: String,
                required: true,
                default: () => '',
            },
            maxBookingLength: {
                type: Number,
                required: false,
                default: () => 0,
            },
            maxChildAge: {
                type: Number,
                required: false,
                default: () => 15,
            },
            defaultChildAge: {
                type: Number,
                required: false,
                default: () => 0,
            },            
            heightThresholdTurnOn: {
                type: String,
                required: false,
                default: () => '',
            },
            buyTicketsOnlyLinkUrl: {
                type: String,
                required: false,
                default: () => '',
            },            
            texts: {
                modalHeadline: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                adultsSingle: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                adultsPlural: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                adultsAgeDescription: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                childrenSingle: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                childrenPlural: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                childrenAgeDescription: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                headingGuests: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                headingCheckInOut: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                dropdownDefault: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                age: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                searchButton: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                adultsErrorText: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                childrenErrorText: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                datesErrorText: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                heightThresholdInputText: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                heightThresholdExtraText: {
                    type: String,
                    required: false,
                    default: () => '',
                },                
                buyTicketsOnlyLinkText: {
                    type: String,
                    required: false,
                    default: () => '',
                }                
            },
            isoSettings: {
                formAction: {
                    type: String,
                    required: true,
                    default: () => '',
                },
                packageCode: {
                    type: Boolean,
                    required: true,
                    default: () => false,
                },
                salesChannelCode: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                hotelCode: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                workflow: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                code: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                utmSource: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                utmMedium: {
                    type: String,
                    required: false,
                    default: () => '',
                },
                utmCampaign: {
                    type: String,
                    required: false,
                    default: () => '',
                }
            },
        },
        data() {
            return {
                adultsLabelID: 'id-' + uuidv4().substring(0,8),
                childrenLabelID: 'id-' + uuidv4().substring(0,8),
                showDialog: false,
                datesSet: false,
                i18nFallback: {
                    name: 'en-US',
                    firstDayOfWeek: 0,
                    data: {
                        night: 'Night',
                        nights: 'Nights',
                        week: 'Week',
                        weeks: 'Weeks',
                        'day-names': ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],
                        'check-in': 'Check-in',
                        'check-out': 'Check-out',
                        'month-names': [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                        ],
                        tooltip: {
                        halfDayCheckIn: 'Available CheckIn',
                        halfDayCheckOut: 'Available CheckOut',
                        saturdayToSaturday: 'Only Saturday to Saturday',
                        sundayToSunday: 'Only Sunday to Sunday',
                        minimumRequiredPeriod: '%{minNightInPeriod} %{night} minimum.',
                        },
                    },
                    format: 'MM-DD-YYYY'
                },
                datePickerKey: 0,
                startDate: '',
                endDate: '',
                minDate: '',
                maxDate: '',
                maxAdults: 8,
                maxChildren: 8,
                defaultChildAge: this.$props.defaultChildAge,
                childHeightThresholdChecked: [],
                selectGuests: false,
                guests: {
                    adults: 0,
                    infants: 0,
                    children: []
                },
                collectedDates: [],
                disabledDates: [],
                disabledDatesBetween: [],
                errors: {
                    dates: false,
                    adults: false,
                    children: false
                },
                range: {},
                startDateClicked: false,
                showDatePicker: false,
                showAgeSelector: false,
                extendedEndDate: null,
            }
        },
        mounted() {
            const dialogElement = this.$refs.dialog;
            dialogPolyfill.registerDialog(dialogElement);

            //Populate ISO fields with default values
            this.$refs.formWorkFlow.value = this.$props.isoSettings.workflow;
            this.$refs.formCode.value = this.$props.isoSettings.code;
            this.$refs.formHotelCode.value = this.$props.isoSettings.hotelCode;
            this.$refs.formSalesChannelCode.value = this.$props.isoSettings.salesChannelCode;
            this.$refs.formUtmSource.value = this.$props.isoSettings.utmSource;
            this.$refs.formUtmMedium.value = this.$props.isoSettings.utmMedium;
            this.$refs.formUtmCampaign.value = this.$props.isoSettings.utmCampaign;
        },
        watch: {
            showDatePicker: {
                handler() {
                    const bookingBar = document.querySelector('.iso-booking-form-bottom-bar');

                    if(this.showDatePicker) {
                        bookingBar.classList.add('iso-booking-form-bottom-bar--show-datepicker');
                    } else {
                        bookingBar.classList.remove('iso-booking-form-bottom-bar--show-datepicker');
                    }
                },
            },
        },
        methods: {
            clickOutsideDatepicker(evt) {
                if(evt.target?.closest('.' + this.$refs.datepicker.classList.value) == null && this.$props.isBottomBar) {
                    this.showDatePicker = false;
                }
            },
            clickOutsideAgeSelector(evt) {
                if(evt.target?.closest('.iso-booking-form__ages-increment-decrement-button') == null && this.$props.isBottomBar) {
                        this.showAgeSelector = false;
                }
            },
            clickChildrenSelector() {
                if(this.guests.children.length > 0) {
                    this.showAgeSelector = true;
                }
            },
            getCalendarStartPosition() {
                if(this.$props.availableDates.length > 0) {
                    const date = new Date(this.$props.availableDates[0]); 
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();

                    return { month, year }
                }
            },
            //Select day with enter/space
            onDayEnter(day, evt) {
                if(evt.key === 'Enter' || evt.key === ' ') {
                    this.onDayClick(day);
                }
            },
            //Select day with mouse click
            onDayClick(day) {
                const chosenDate = new Date(day.year, day.month - 1, day.day);

                if(this.$props.maxBookingLength > 0) {
                    if(!this.startDateClicked) {
                        const chosenStartDate = chosenDate;

                        this.attributes = [{
                            //Disable all dates
                            content: {
                                style: { pointerEvents: 'none', color: '#cbd5e0' },
                            },
                            dates: [{start: null, end: null}],
                            order: 0
                        },
                        {
                            //Enable selectable days forward
                            content: {
                                style: { pointerEvents: 'auto', color: '#000' }
                            },
                            dates: [{start: chosenStartDate, span: this.$props.maxBookingLength + 1 }],
                            order: 1
                        },
                        {
                            //Highlight selected day
                            content: {
                                class: 'selected-date'
                            },
                            dates: [chosenStartDate],
                            order: 2
                        }];
                    }
                }
                if(this.startDateClicked) {
                    //End date clicked
                    this.showDatePicker = false;
                    this.endDate = chosenDate;
                    this.$refs.formEndDate.value = this.dateFormatter(chosenDate);
                    this.errors.dates = false;
                } else {
                    //Start date clicked
                    this.startDateClicked = true;
                    this.startDate = chosenDate;
                    this.$refs.formStartDate.value = this.dateFormatter(chosenDate);
                }
            },

            toggleDatePicker() {
                this.startDateClicked = false;
                this.showDatePicker = !this.showDatePicker;
                this.resetCalendar();

                //Fix for esc closing dialog on datepicker toggle, as vendor takes over esc
                document.addEventListener('keydown', (e) => {
                    if (e.key == 'Escape') {
                        this.onCloseDialog();
                    }
                });
            },

            resetCalendar() {
                this.startDate = '';
                this.endDate = '';
                this.errors.dates = false;

                //ISO fields updated
                this.$refs.formStartDate.value = '';
                this.$refs.formEndDate.value = '';

                this.datePickerKey++;
                this.datesSet = false;

                //RESET CALENDAR VISUALLY
                this.attributes = [{
                    // Disable all dates
                    content: {
                        style: { pointerEvents: 'none', color: '#cbd5e0' }
                    },
                    dates: ['*'],
                    order: 0
                },
                { 
                    // Enable available dates
                    content: {
                        style: { pointerEvents: 'all', color: '#123456' }
                    },
                    dates: this.$props.availableDates, //add booking length to end date
                    order: 1
                }];
            },
            onOpenDialog() {
                if(this.$props.isBottomBar) {
                    this.showDialog = true;
                } else {
                    this.showDialog = true;

                    Vue.nextTick(() => {
                        const dialogElement = this.$refs.dialog;
                        dialogElement.showModal();
                    });
                }
            },
            onCloseDialog() {
                const dialogElement = this.$refs.dialog;
                dialogElement.close();

                Vue.nextTick(() => {
                    this.resetCalendar();
                    this.showDatePicker = false;
                    this.resetGuests();
                    this.showDialog = false;
                });
            },
            onClearSelection() {
                this.startDate = '';
                this.endDate = '';
                this.errors.dates = true;
            },
            onSubmit() {
                this.$refs.form.setAttribute('action', this.$props.isoSettings.formAction);

                if (this.errors.children) {
                    const element = this.$refs.childerror;
                    if (element) {
                        this.selectGuests = true;
                        Vue.nextTick(() => {
                            element.scrollIntoView();
                        });
                    }
                }

                if (this.formIsValid) {
                    this.updateHiddenFormElements();

                    Vue.nextTick(() => {
                        this.$refs.form.submit();
                    });
                }
            },
            toggleGuestsSelector() {
                this.selectGuests = !this.selectGuests;
            },
            setNumberOfAdults(value) {
                this.guests.adults = value;

                if(value > 0) {
                    this.errors.adults = false;
                }
            },
            setAdults() {
                this.errors.adults = false;
            },
            setChildren(value) {
                const numberOfChildrenSelected = value;
                const currentChildren = this.guests.children;

                if(value > 0) {
                    this.showAgeSelector = true;
                } else {
                    this.showAgeSelector = false;   
                    this.errors.children = false;
                }

                // We are adding children
                if (numberOfChildrenSelected > currentChildren.length) {
                    const numberOfChildrenToAdd = numberOfChildrenSelected - currentChildren.length;

                    for (let i = 0; i < numberOfChildrenToAdd; i++) {
                        const child = {
                            age: (this.defaultChildAge == 0 || this.defaultChildAge == '') ? null : this.defaultChildAge,
                        }
                        this.guests.children.push(child);
                    }

                    return;
                }

                //If we make it here we are instead removing children
                var array = this.guests.children;
                var filtered = array.filter(function (value, index, arr) {
                    return index < numberOfChildrenSelected;
                });

                this.guests.children = filtered;
            },
            setChildAge(event, index) {
                const val = event.target.value
                this.guests.children[index].age = val;
                this.errors.children =  this.guests.children.some(x => x.age === null);

                if(this.$props.heightThresholdTurnOn == "true") {
                    const parent = event.target.closest('.child-list__item');
                    const chkbox = parent?.querySelector('input[type="checkbox"]');
                    
                    if(this.guests.children[index].age > 2) {
                        chkbox.checked = true;
                        this.childHeightThresholdChecked[index] = true;
                    } else {
                        chkbox.checked = false;
                        this.childHeightThresholdChecked[index] = false;
                    }       
                }             
            },
            setChildHeightThreshold(event, index) {
                this.childHeightThresholdChecked[index] = event.srcElement.checked;
            },
            resetGuests() {
                this.guests.adults = 0;
                this.guests.infants = 0;
                this.guests.children = [];
                this.updateHiddenFormElements();
                this.errors.adults = false;
                this.errors.children = false;
                this.showAgeSelector = false;
            },
            updateHiddenFormElements() {
                //Handle guests
                const arr = [];
                const obj = {...this.guests};
                obj.children = this.guests.children.length;
                obj.childrenAges = [];

                this.guests.children.forEach((child) => {
                    obj.childrenAges.push(parseInt(child.age));

                    if(this.$props.heightThresholdTurnOn == "true") {
                        obj.childrenHeightThreshold = this.childHeightThresholdChecked;
                    }
                });

                arr.push(obj)
                this.$refs.formOccupancy.value = JSON.stringify(arr);
            },
            i18nDateFormatter(inputDate) {
                const locale = document.querySelector('body').dataset.culture;
                return `${new Intl.DateTimeFormat(locale).format(inputDate)}`;
            },
            dateFormatter(inputDate) {
                return `${new Intl.DateTimeFormat('en-US', { year: 'numeric'}).format(inputDate)}-${new Intl.DateTimeFormat('en-US', { month: '2-digit'}).format(inputDate)}-${new Intl.DateTimeFormat('en-US', { day: '2-digit'}).format(inputDate)}`;
            },
            getDisabledDates(array) {
                var result = array.sort(function(a, b) {
                    return Date.parse(a) - Date.parse(b);
                }).reduce(function(hash){
                    return function(p,c){
                        var missingDaysNo = (Date.parse(c) - hash.prev) / (1000 * 3600 * 24);

                        if(hash.prev && missingDaysNo > 1) {
                            for(var i = 1; i < missingDaysNo; i++)
                                p.push(new Date(hash.prev+i*(1000 * 3600 * 24)));
                        }

                        hash.prev = Date.parse(c);

                        return p;
                    };

                }(Object.create(null)), []);

                return result;
            },
            getDisabledDateArray() {
                if(this.$props.availableDates != null) {
                    var disabledDateArr = this.getDisabledDates(this.$props.availableDates.map(date => {
                        if(date != null) {
                            return new Date(date)
                        }
                    }));

                    return disabledDateArr;
                }
            },
        },
        computed: {
            getCheckinText() {
                let arr = i18n.filter(x => x.name.toLowerCase() === this.$props.i18n.toLowerCase());

                if (!arr || arr.length === 0) {
                    arr = [this.i18nFallback]
                }

                if (this.startDate) {
                    return `${this.i18nDateFormatter(this.startDate)}`;
                }

                return arr[0].data['check-in'];
            },
            getCheckoutText() {
                let arr = i18n.filter(x => x.name.toLowerCase() === this.$props.i18n.toLowerCase());

                if (!arr || arr.length === 0) {
                    arr = [this.i18nFallback];
                }

                if(this.endDate) {
                    this.datesSet = true;
                    return `${this.i18nDateFormatter(this.endDate)}`;
                }

                return arr[0].data['check-out'];
            },
            getLocale() {
                const locale = document.querySelector('body')?.dataset.locale;
                return { id: locale, firstDayOfWeek: this.getFirstDayOfWeek +1, masks: { weekdays: 'WWW' } };
            },
            getFirstDayOfWeek() {
                const arr = i18n.filter(x => x.name.toLowerCase() === this.$props.i18n.toLowerCase());

                if (!arr || arr.length === 0) {
                    return 0; //Sunday
                }

                return arr[0].firstDayOfWeek;
            },
            formIsValid() {
                this.errors.dates = (this.startDate === null || this.startDate === '' || this.startDate === undefined || this.endDate === null || this.endDate === '' || this.endDate === undefined);
                this.errors.adults = this.guests.adults <= 0;
                this.errors.children = (this.guests.children.length > 0 && this.guests.children.some(x => x.age === null));

                if (this.errors.adults || this.errors.children) {
                    this.selectGuests = true;
                }

                if (this.errors.dates || this.errors.adults || this.errors.children) {
                    console.log('Theres an error: ', this.errors);
                    return false;
                }

                return true;
            }
        }
    };
</script>
